<template>
    <div id="divUnsubscribe" v-if="displayUnsubscribeContent">
        <div class="header-nav">
            <ul class="menu">
                <li><span>{{ $t("message.unsubscribe") }}</span></li>
            </ul>
        </div>

        <div id="divContent" class="main-content-row">
            <!-- Only show this message if we have a valid email address -->
            <div id="divUnsubscribeStatus" v-if="unsubscribeDetails.UnsubscribedEmail.length > 0">
                <p v-if="isUnsubscribeSuccessful">{{ $t("message.unsubscribeSuccessText", { email: unsubscribeDetails.UnsubscribedEmail }) }}</p>
                <p v-else>{{ $t("message.unsubscribeFailText", { email: unsubscribeDetails.UnsubscribedEmail }) }}</p>
            </div> 
            <!-- Always display the Login link to the user so they can go back to Client Login page -->           
            <div id="divUnsubscribeMessage">
                <a v-bind:href="unsubscribeDetails.ClientPortalLoginUrl">{{ $t("message.unsubscribeLoginText") }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: 'Unsubscribe',
        data() {
            return {
                displayUnsubscribeContent: false,
                isUnsubscribeSuccessful: false,
                unsubscribeDetails: ''
            }
        },
        mounted() {
            this.unsubscribeEmailAndDisplayMessage();
        },
        methods: {
            getUnsubscribeDetails() {
                // Fetch all details that we need to display Unsubscribe content.
                axios({
                    method: "GET",
                    url: this.$httpAxiosBaseUrl() + "Login/GetUnsubscribeDetails"
                }).then(result => {
                    var response = result.data;
                    if (response !== '') {
                        this.unsubscribeDetails = response;
                        this.displayUnsubscribeContent = true;
                    }
                }, error => {
                    console.log(error);
                });
            },
            unsubscribeEmailAndDisplayMessage() {
                // We are only going to allow access to this page if a valid Status value is passed in from handleRedirect.aspx page.
                // If it's undefined we will return the user back to Login page.
                var unsubscribeStatus = decodeURI(this.$route.query.Status);
                if (unsubscribeStatus === 'undefined') {
                    this.redirectToLogin();
                }

                // Let's get Unsubscribe details that we need for display.
                this.getUnsubscribeDetails();

                // Based on our Status value we will show/hide unsubscribe message OR redirect the user back to Login if Status value is not valid.
                // If SSO setting is turned on, 'Not authorized' message will show up on Login page.
                switch(unsubscribeStatus) {
                    case "1":
                        this.isUnsubscribeSuccessful = true;
                        break;
                    case "0":
                        this.isUnsubscribeSuccessful = false;
                        break;
                    default:
                        this.redirectToLogin();
                        break;
                }
            },
            redirectToLogin() {
                this.$router.push({ name: 'Login' });
                return;
            }
        }
    }
</script>
